/* OI8B delivery estimate: asks Shopify's own Storefront API (tokenless cart) for the real checkout
   delivery options for the shopper's country, in their currency. Uses a throwaway cart, so the
   shopper's real cart is never changed. No hard-coded prices. */
(function () {
  if (window.OI8BDelivery) return;
  var API = '/api/2025-07/graphql.json';
  // Sample postcodes (not prices) so Shopify can resolve flat country-wide rates where it needs an address.
  var ADDR = {US:['10001','NY','New York'],ES:['28001','','Madrid'],DE:['10115','','Berlin'],FR:['75001','','Paris'],
    IT:['00118','RM','Roma'],NL:['1012 JS','','Amsterdam'],IE:['D02 X285','D','Dublin'],BE:['1000','','Brussels'],
    PT:['1100-148','','Lisboa'],AT:['1010','','Wien'],SE:['111 20','','Stockholm'],DK:['1050','','København'],
    FI:['00100','','Helsinki'],PL:['00-001','','Warszawa'],CA:['M5H 2N2','ON','Toronto'],AU:['2000','NSW','Sydney'],
    NZ:['1010','AUK','Auckland'],JP:['100-0001','JP-13','Tokyo'],CH:['8001','','Zürich'],NO:['0150','','Oslo'],
    LU:['1111','','Luxembourg'],GR:['105 57','','Athina'],CZ:['110 00','','Praha'],HU:['1051','','Budapest'],RO:['010011','B','Bucuresti']};
  var DAYS = {GB:'UK delivery 4–8 business days',US:'US delivery 3–6 business days',CA:'delivery 3–10 business days',
    AU:'delivery 3–20 business days',EU:'delivery 4–10 business days'};
  var EU = 'AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE'.split(',');
  var cache = {};
  function q(lines, country, ctx, addr) {
    var a = {country: country};
    if (addr) { a.zip = addr[0]; if (addr[1]) a.province = addr[1]; a.city = addr[2]; }
    var query = 'mutation($l:[CartLineInput!],$c:CountryCode!,$a:MailingAddressInput!) @inContext(country:' + ctx + '){cartCreate(input:{lines:$l,buyerIdentity:{countryCode:$c,deliveryAddressPreferences:[{deliveryAddress:$a}]}}){cart{deliveryGroups(first:10){nodes{deliveryOptions{title estimatedCost{amount currencyCode}}}}}}}';
    return fetch(API, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({query: query, variables: {l: lines, c: country, a: a}})})
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var g = (((d.data || {}).cartCreate || {}).cart || {}).deliveryGroups;
        if (!g || !g.nodes.length) return null;
        var total = 0, cur = null;
        for (var i = 0; i < g.nodes.length; i++) {
          var opts = g.nodes[i].deliveryOptions; if (!opts.length) return null;
          var min = opts.reduce(function (m, o) { return (!m || +o.estimatedCost.amount < +m.estimatedCost.amount) ? o : m; }, null);
          total += +min.estimatedCost.amount; cur = min.estimatedCost.currencyCode;
        }
        return {amount: total, currency: cur};
      });
  }
  function estimate(lines, country, ctx) {
    var key = JSON.stringify([lines, country, ctx]);
    if (!cache[key]) cache[key] = q(lines, country, ctx, null).then(function (r) {
      return r || (ADDR[country] ? q(lines, country, ctx, ADDR[country]) : null);
    }).catch(function () { return null; });
    return cache[key];
  }
  function fmt(r, locale) {
    if (r.amount === 0) return 'free';
    try { return new Intl.NumberFormat(locale || document.documentElement.lang || 'en', {style:'currency', currency:r.currency}).format(r.amount); }
    catch (e) { return r.amount.toFixed(2) + ' ' + r.currency; }
  }
  function days(c) { return DAYS[c] || (EU.indexOf(c) > -1 ? DAYS.EU : ''); }
  window.OI8BDelivery = {estimate: estimate, fmt: fmt, days: days};
})();
